import { Container } from '../../components/container/container';
import { Page } from '../../components/page-layout/page';
import { createFileRoute } from '../../utils/route-factory';

function RouteComponent() {
  return (
    <Page
      title='Sync Apps'
      breadcrumbs={[
        {
          label: 'Sync Apps',
        },
        {
          label: 'All Sync App',
        },
      ]}
    >
      <Container>TODO</Container>
    </Page>
  );
}

export const Route = createFileRoute({
  path: '/sync-app/',
  component: RouteComponent,
  type: 'auth',
});
